<template>
  <div class="swiperthree">
    <div class="swiper mySwiper1">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in hfliat.swipeImgList_cyfw" v-bind:key="index">
          <a :href="item.link">
            <div class="serboxctit">
              <div class="actit mmmmmmmmmt">
                <span>{{ item.title }}</span>
              </div>
            </div>
            <div class="serboxcimg" style="width:374px; border:1px solid #d9d9d9">
              <img :src="item.src" style="width: 100%; height: 221px;" alt="" />
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "@/swiper/swiper-bundle.min.js";
import { detail } from "@/api/index.js";

export default {
  name: "swiperthree",
  data() {
    return {
      hfliat: [],
    };
  },
  created() {
    this.handleheadfoot();
  },
  methods: {
    // 头部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
        //
      });
    },
  },
  mounted: function () {
    var swiper = new Swiper(".mySwiper1", {
      watchSlidesProgress: true,
      slidesPerView: 3,
      autoplay: {
        delay: 8000, //3秒切换一次
        pauseOnMouseEnter: true, //悬停停止切换
      },
    });
  },
};
</script>
<style lang="less" scoped>
.swiperthree {
  max-width: 1200px;
  // min-width: 360px;
  max-height: 375px;
}

.swiper-slide:first-child {
  margin-left: 0;
  margin-right: 0;
}
.swiper-slide > a > img {
  max-width: 374px;
  max-height: 221px;
}
.serboxctit {
  width: 374px;
}
.serboxctit {
  @media screen and (max-width: 360px) {
    display: none;
  }
}
</style>
